import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from '../../../../../components/Link';

export interface ExpiredJobBannerProps {
  backHref: string;
}

/**
 * Shown when the job is still in the index but treated as expired (HTTP 410).
 */
export function ExpiredJobBanner({ backHref }: ExpiredJobBannerProps) {
  return (
    <div
      role="status"
      className="mb-4 rounded-xl border border-[#C4A882]/50 bg-[#F5EDD0] px-4 py-3 dark:border-[#D4A820]/20 dark:bg-[#2A1E08]"
    >
      <p className="text-sm leading-relaxed text-[#3D3529] dark:text-[#C4A882]">
        <FormattedMessage
          id="jobDetailPage.expired.banner"
          defaultMessage="This listing may be too old or no longer active. {link}"
          description="Banner on expired job pages; link is replaced by a return-to-search control"
          values={{
            link: (
              <Link
                href={backHref}
                className="font-medium text-[#3B5E45] underline decoration-[#3B5E45]/30 underline-offset-2 hover:text-[#2A4533] dark:text-[#98CFA8] dark:decoration-[#98CFA8]/30 dark:hover:text-[#B6D4BC]"
              >
                <FormattedMessage
                  id="jobDetailPage.expired.backToSearch"
                  defaultMessage="Back to search results"
                  description="Link from expired job banner back to the jobs listing hub"
                />
              </Link>
            ),
          }}
        />
      </p>
    </div>
  );
}
